import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
    makeRequest(
        'put',
        `/api/participations/${participationID}/draft-assessments`,
        payload
    );


// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/updateDraftParticipantAssessment.js